import { useMutation } from '@apollo/client'
import { Button, ConfirmationModal } from '@chain-zen/ui'
import { useState } from 'react'
import { toast } from 'sonner'

import { REMOVE_STOP } from '../../../../../data/mutations/stops'
import { MY_SHIPMENT } from '../../../../../data/queries/shipment'
import { removeArrayItemFromCache } from '../../../../../utils/graphql-cache'
import { useStops } from './contexts/use-stops-context'

/**
 * This component is used to remove a stop from the shipment.
 */
export const RemoveStopButton = ({ stopID }: { stopID: string }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { shipment } = useStops()

  const [removeStop, { loading }] = useMutation(REMOVE_STOP, {
    onCompleted: () => {
      toast.success('Stop removed')
      setIsOpen(false)
    },
    onError: (error) => {
      toast.error(error.message)
    },
    refetchQueries: [
      {
        query: MY_SHIPMENT,
        variables: { id: shipment.id }
      }
    ],
    update: removeArrayItemFromCache({
      fieldName: 'stops',
      id: shipment.id,
      mutationReturnValueFieldName: 'removeStop',
      typename: 'Shipment'
    })
  })

  const handleRemoveStop = () => {
    toast.info('Removing stop...')
    removeStop({
      context: {
        headers: { 'ws-id': shipment.shipmentOwnerWorkspace?.id }
      },
      variables: { shipmentID: shipment.id, stopID: stopID }
    })
  }

  return (
    <ConfirmationModal
      trigger={<Button variant="destructive">Remove Stop</Button>}
      title="Remove Stop"
      description="Are you sure you want to remove this stop? This action cannot be undone."
      confirmText={loading ? 'Removing...' : 'Remove'}
      isLoading={loading}
      open={isOpen}
      onOpenChange={setIsOpen}
      onConfirm={handleRemoveStop}
      isDestructive={true}
    />
  )
}
